export const getWidth = (columns) => `${60 / columns}%`;
